import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom-v5-compat";
import Banner from "../../../components/Banner";
import TataCara from "../../../assets/imgDF/Tatacara.png";
import PendaftaranPPID from "../../../assets/imgDF/Pendaftaran.png";
import Pagination from "react-bootstrap/Pagination";

import "../../../assets/css/LayananPublik.css";

const Index = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(4);
  const [totalPages, setTotalPages] = useState(1);

  const data = [
    {
      imageSrc: TataCara,
      title: "Tata Cara Permohonan Informasi",
      link: "/ppid/pengaduan-publik/permohonan-informasi",
    },
    {
      imageSrc: PendaftaranPPID,
      title: "Formulir Permohonan Informasi ",
      second_title: "(Datang Langsung)",
      link: "/ppid/formulir/informasi-publik/offline",
      slug: "formulir-offline",
    },
    {
      imageSrc: PendaftaranPPID,
      title: "Formulir Permohonan Informasi",
      second_title: "(Online)",
      link: "https://data.jabarprov.go.id/form/s/b6d8bc23-1bc5-403e-97db-e67d60a60bf7",
      isExternal: true,
    },
    {
      imageSrc: TataCara,
      title: "Tata Cara Pengaduan Keberatan Terkait Permohonan Informasi",
      link: "/ppid/pengaduan-publik/permohonan-pengaduan",
    },
    {
      imageSrc: PendaftaranPPID,
      title: "Formulir Pengaduan Keberatan Terkait Permohonan Informasi ",
      second_title: "(Datang Langsung)",
      link: "/ppid/formulir/informasi-publik/offline",
      slug: "formulir-offline",
    },
    {
      imageSrc: PendaftaranPPID,
      title: "Formulir Pengaduan Keberatan Terkait Permohonan Informasi",
      second_title: "(Online)",
      link: "https://data.jabarprov.go.id/form/s/2026c82d-458b-4d3c-8f0e-96fe1cd01169",
      isExternal: true,
    },
  ];

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setTimeout(() => {
      document
        .getElementById("primary-section")
        .scrollIntoView({ behavior: "smooth" });
    }, 10);
  };

  const currentData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setItemsPerPage(3); // Jumlah item per halaman untuk tampilan mobile
      } else {
        setItemsPerPage(6); // Jumlah item per halaman untuk tampilan web
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const newTotalPages = Math.ceil(data.length / itemsPerPage);
    setTotalPages(newTotalPages);

    if (currentPage > newTotalPages) {
      setCurrentPage(newTotalPages);
    }
  }, [itemsPerPage, currentPage]);

  return (
    <>
      <div id="primary-section">
        <Banner
          menu={"Permohonan Informasi Publik"}
          desc={
            "Dapatkan permohonan terkait informasi publik di Dinas Pendidikan Jawa Barat."
          }
        />
        <div className="container">
          <div className="section most-played ">
            <div className="row">
              <div className="container">
                <div className="section most-played ">
                  <div className="row">
                    {currentData.map((item, index) => (
                      <div className="col-lg-4 col-md-4 col-sm-4" key={index}>
                        <div className="profile profile-item">
                          <div className="profile-smallimg">
                            <div className="profile__image">
                              <div className="profile__border">
                                <img
                                  src={item.imageSrc}
                                  alt="Doggo"
                                  width="80"
                                />
                              </div>
                            </div>
                            <div className="profile__info">
                              <h6>{item.title}</h6>{" "}
                              <h5>
                                {item.second_title}
                                <br />
                              </h5>
                            </div>
                            <div className="profile__cta">
                              {item.isExternal ? (
                                <a
                                  href={item.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="button"
                                >
                                  Lihat Selengkapnya
                                </a>
                              ) : (
                                <Link
                                  to={{
                                    pathname: item.link,
                                  }}
                                  state={{
                                    title: item.title,
                                    second_title: item.second_title,
                                    slug: item.slug,
                                  }}
                                  className="button"
                                >
                                  Lihat Selengkapnya
                                </Link>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pagination-container-mobile">
            <Pagination>
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {Array.from({ length: totalPages }, (_, index) => (
                <Pagination.Item
                  key={index}
                  active={index + 1 === currentPage}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
              <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
